export default __webpack_public_path__ + "static/media/icon-yeti.048b5fa5.png";